import React from "react";
import ShowTemplate from "./ShowTemplate";
import ChooseTemplateHeader from "../assets/resources/ChooseTemplateHeader";
import TemplateGrid from "../assets/resources/TemplateGrid";

const TEMPLATES = [
  { id: "classic",       name: "Classic",                          image: require("../assets/img/SaveDate/classic.png") },
  { id: "sakura",        name: "Sakura",                           image: require("../assets/img/SaveDate/sakura.png") },
  { id: "goldDots",      name: "Gold Dots",                        image: require("../assets/img/SaveDate/goldDots.png") },
  { id: "wreath",        name: "Gold Wreath",                      image: require("../assets/img/SaveDate/wreath.png") },
  { id: "marsalaFloral", name: "Marsala Burgundy Floral",          image: require("../assets/img/SaveDate/marsalaFloral.png") },
  { id: "silverGlitter", name: "Silver Glitter",                   image: require("../assets/img/SaveDate/silverGlitter.png") },
  { id: "goldGlitter",   name: "Rose Gold Glitter Flowers",        image: require("../assets/img/SaveDate/goldGlitter.png") },
  { id: "modernMinimalist", name: "Modern Minimalist", tag: "new", image: require("../assets/img/SaveDate/modernMinimalist.svg").default },
  { id: "botanicalSage",    name: "Botanical Sage",     tag: "new", image: require("../assets/img/SaveDate/botanicalSage.svg").default },
  { id: "gildedArch",       name: "Gilded Arch",        tag: "new", image: require("../assets/img/SaveDate/gildedArch.svg").default },
  { id: "custom",        name: "Place your pre-made design", tag: "your own", image: require("../assets/img/Other/CustomDesign.png") },
];

class ChooseTemplate extends React.Component {
  constructor() {
    super();
    this.template = "";
  }

  ChangeTemplate = (word) => {
    this.template = word;
    this.setState({ changed: true });
    window.scrollTo(0, 0);
  };

  render() {
    if (this.template !== "") {
      return <ShowTemplate template={this.template} />;
    }
    return (
      <>
        <ChooseTemplateHeader category="Save the Date" />
        <TemplateGrid
          templates={TEMPLATES}
          customFormPath="/Save-Date-Custom-Form"
          onSelect={this.ChangeTemplate}
        />
      </>
    );
  }
}

export default ChooseTemplate;
